/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createSlice } from '@reduxjs/toolkit';
import { getAllRole, getRoleHistory } from './roleAction';
 
const initialState = {
    data: {},
    roles: {},
    roleHistory: {}
}
const roleSlice = createSlice({
    name: 'role',
    initialState,
    extraReducers: {

        [getAllRole.fulfilled]: (state, { payload }) => {
            state.roles =  payload;
        },
        [getRoleHistory.fulfilled]: (state, { payload }) => {
            state.roleHistory =  payload;
        },
        [getRoleHistory.rejected]: (state, { payload }) => {
            state.roleHistory =  {};
        },
    }
});

export default roleSlice.reducer